/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_preset_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes — a short alarm beep plays when the countdown reaches zero. Make sure your device isn't muted.`)
};

const es_timer_preset_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí — suena un breve pitido de alarma cuando la cuenta regresiva llega a cero. Asegúrate de que tu dispositivo no esté en silencio.`)
};

const de_timer_preset_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja — ein kurzer Alarmton ertönt, wenn der Countdown null erreicht. Stelle sicher, dass dein Gerät nicht stummgeschaltet ist.`)
};

const nl_timer_preset_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja — er klinkt een kort alarmsignaal zodra de aftelling nul bereikt. Zorg dat je apparaat niet gedempt staat.`)
};

const fr_timer_preset_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui — un court bip d’alarme retentit lorsque le compte à rebours atteint zéro. Assurez-vous que votre appareil n’est pas en sourdine.`)
};

const it_timer_preset_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì — un breve segnale acustico suona quando il countdown raggiunge lo zero. Assicurati che il dispositivo non sia silenziato.`)
};

const pt_br2_timer_preset_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim — um breve bipe de alarme toca quando a contagem regressiva chega a zero. Certifique-se de que seu dispositivo não esteja no mudo.`)
};

const pt_timer_preset_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim — soa um breve sinal de alarme quando a contagem decrescente chega a zero. Certifique-se de que o seu dispositivo não está em silêncio.`)
};

const ja_timer_preset_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい、カウントダウンが0になると短いアラーム音が鳴ります。デバイスがミュートになっていないか確認してください。`)
};

const zh_timer_preset_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会 — 倒计时归零时会播放一段短闹铃提示音。请确保设备未静音。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_preset_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_preset_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_preset_faq2_a", locale)
	if (locale === "en") return en_timer_preset_faq2_a(inputs)
	if (locale === "es") return es_timer_preset_faq2_a(inputs)
	if (locale === "de") return de_timer_preset_faq2_a(inputs)
	if (locale === "nl") return nl_timer_preset_faq2_a(inputs)
	if (locale === "fr") return fr_timer_preset_faq2_a(inputs)
	if (locale === "it") return it_timer_preset_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_timer_preset_faq2_a(inputs)
	if (locale === "pt") return pt_timer_preset_faq2_a(inputs)
	if (locale === "ja") return ja_timer_preset_faq2_a(inputs)
	return zh_timer_preset_faq2_a(inputs)
};